import React from 'react';
import { formatDistance } from '@lt/components/utils/userflow';
import { DistanceSkiLift } from '@lt/components/icons-react/rebrand';
import HotelFeature from '../HotelFeature';

import styles from './SkiLiftDistanceFeature.module.css';

type SkiLiftDistanceFeatureProps = {
  value: number;
  isMobile: boolean;
};

const SkiLiftDistanceFeature: React.FC<SkiLiftDistanceFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature
      Label={formatDistance(value)}
      Icon={<DistanceSkiLift className={styles.icon} />}
      isMobile={isMobile}
    />
  ) : null;

export default SkiLiftDistanceFeature;
